import { MenuItem, Select } from "@material-ui/core";
import { useUserDispatch, setUserBuilding } from "../../../context";
import { useLoggedUserInfo } from "../../../hooks";

export interface BuildingSelectorProps {
  onUserBuildingChange?: () => void;
}

export function BuildingSelector(props: BuildingSelectorProps) {
  const { onUserBuildingChange } = props;

  const dispatch = useUserDispatch();
  const { userBuilding, userBuildings } = useLoggedUserInfo();

  const triggerBuildingChange = (id: string) => {
    setUserBuilding(
      dispatch,
      userBuildings?.find((v) => v.id === id)
    );
    onUserBuildingChange && onUserBuildingChange();
  };
  return (
    <Select
      variant="outlined"
      style={{
        width: "100%",
      }}
      value={userBuilding?.id}
      onChange={(evt) => triggerBuildingChange(evt.target.value as string)}
    >
      {Boolean(userBuilding) && (
        <MenuItem value={void 0}>Annulla selezione</MenuItem>
      )}
      {userBuildings?.map((building, index) => (
        <MenuItem key={index} value={building.id}>
          {building.name}
        </MenuItem>
      ))}
    </Select>
  );
}
